import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { Item } from '../../models/item';
import { CompanyAddress } from '../../models/direccionconpania';
import { MatOptionSelectionChange, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ItemSubFamily } from '../../models/item-subfamily';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'app-add-companyAddress',
    templateUrl: 'direccionEmpresa-agregar.component.html',
    styleUrls: [],
    providers: [generalService]
  })

  export class CompanyAddressAddEditComponent implements OnInit {
    private companyAddress :CompanyAddress = new CompanyAddress();;
    public title = '';
    private loacs: string;
    private CompanyAddres_ID = undefined;
    public dataCompany: any[] = [];
    public nombreCompaniaTxt = '';
   
    public esActualizacion = false;
    public company: Item;
    public direccionCompaniaForm: FormGroup;
    public btnStatus = "";
    public actualizar = false;
    public paises: any[] = [];
    public estados: any[] = [];
    public estadosAUX: any[] = [];
    public ciudades: any[] = [];
    public ciudadesAUX: any[] = [];
    public localidades: any[] = [];
    public localidadAUX: any[] = [];
    public codigoPostal: any[] = [];
    public codigoPostalAUX: any[] = [];
    public postalCodeAux: any[] = [];
    public colonias: any[] = [];
    public coloniasAUX: any[] = [];
    timeout: any;
    constructor(private router: Router,private formBuilder: FormBuilder,
    private _generalService: generalService,private route: ActivatedRoute,) {
    this.company = new Item();
    this.direccionCompaniaForm = new FormGroup({});
    this.CompanyAddres_ID = this.route.snapshot.paramMap.get('id'); 
    }

    ngOnInit(){
      this.validateRoute();
      this.buildDriverForm();
      this.consultarDataCompanyAddress();
      
    }

    validateRoute() {
        if (this.CompanyAddres_ID === 'N') {
          this.title = 'guardado';
          this.btnStatus = "Agregar";
        }else{
          this.title = 'actualizado';
          this.btnStatus = "Actualizar";
        }
    }
    backward() {
        this.router.navigate(['app/dirección-compañia']);
    }

    buildDriverForm(){
      this.direccionCompaniaForm = this.formBuilder.group({
        // General data
        NAME: this.formBuilder.control(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
        OUTDOOR_NUMBER: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        STREET: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        INTERIOR_NUMBER: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        REFERENCE: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        pais:  this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        estado: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        ciudad: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        localidad: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        CP: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        colonia: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
      });
    }
    
    //msj de validacion del campo nombre
    get nameCompanyControl() {
      return this.direccionCompaniaForm.get('NAME');
    }

    consultarDataCompanyAddress(){
      let metodo = 'DireccionCompania/getDataCompanyAddress';
     
      const params = { 
          loacs: sessionStorage.getItem('acslo'),
          COMPANY_ADDRESS_ID:this.CompanyAddres_ID
      };

      this._generalService.metodoCallParams(params, metodo).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          this.paises = tableResult.Table; 
          this.estados = tableResult.Table1;
          this.ciudades = tableResult.Table2;
          this.localidades = tableResult.Table3;
          this.codigoPostal = tableResult.Table4;
          this.colonias = tableResult.Table5;
          this.dataCompany = tableResult.Table6;
         

          if (this.dataCompany.length > 0){


            this.direccionCompaniaForm.get('NAME').setValue(this.dataCompany[0].NAME);
            this.direccionCompaniaForm.get('STREET').setValue(this.dataCompany[0].STREET);
            this.direccionCompaniaForm.get('OUTDOOR_NUMBER').setValue(this.dataCompany[0].OUTDOOR_NUMBER);
            this.direccionCompaniaForm.get('INTERIOR_NUMBER').setValue(this.dataCompany[0].INTERIOR_NUMBER);
            this.direccionCompaniaForm.get('REFERENCE').setValue(this.dataCompany[0].REFERENCE);

            this.direccionCompaniaForm.get('pais').setValue(this.dataCompany[0].COUNTRY_ID);
            this.direccionCompaniaForm.get('estado').setValue(this.dataCompany[0].STATE_ID);
            this.direccionCompaniaForm.get('ciudad').setValue(this.dataCompany[0].CITY_ID);

            this.direccionCompaniaForm.get('localidad').setValue(this.dataCompany[0].LOCATION_ID);
            this.direccionCompaniaForm.get('CP').setValue(this.dataCompany[0].POSTAL_CODE_ID);
            this.direccionCompaniaForm.get('colonia').setValue(this.dataCompany[0].SUBURB_ID);
            
            //setearSelect
            this.estadosAUX = this.estados.filter((element) => element.COUNTRY_ID === this.dataCompany[0].COUNTRY_ID);
            this.ciudadesAUX = this.ciudades.filter((element) => element.STATE_ID === this.dataCompany[0].STATE_ID);
            this.localidadAUX = this.localidades.filter((element) => element.STATE_ID ===this.dataCompany[0].STATE_ID);
            this.codigoPostalAUX = this.codigoPostal.filter(element => element.STATE_ID === this.dataCompany[0].STATE_ID).slice(0, 10);
            // Verificar si this.dataCompany[0].POSTAL_CODE_ID cumple con la condición y agregarlo a this.codigoPostalAUX para que salga en el listado
            const postalCodeId = this.dataCompany[0].POSTAL_CODE_ID;
            const found = this.codigoPostalAUX.find(element => element.POSTAL_CODE_ID === postalCodeId);
            if (!found && postalCodeId) {
                this.codigoPostalAUX.push(this.codigoPostal.find(element => element.POSTAL_CODE_ID === postalCodeId));
            }
            this.postalCodeAux = this.codigoPostal.filter((element) => element.STATE_ID === this.dataCompany[0].STATE_ID);
            this.coloniasAUX = this.colonias.filter((element) => element.POSTAL_CODE_ID === this.dataCompany[0].POSTAL_CODE_ID);

            this.nombreCompaniaTxt = this.dataCompany[0].NAME;
          } 
    
        },
        error => {  console.log(<any>error);  }
      );
    }

    setearSelect(event: any, opcion: number){
      switch (opcion) {
        case 1:
          this.estadosAUX = this.estados.filter((element) => element.COUNTRY_ID === event.value);
          
        break;
        case 2:
          this.ciudadesAUX = this.ciudades.filter((element) => element.STATE_ID === event.value);
          this.localidadAUX = this.localidades.filter((element) => element.STATE_ID === event.value);
          this.codigoPostalAUX = this.codigoPostal.filter((element) => element.STATE_ID === event.value).slice(0, 10);
          this.postalCodeAux = this.codigoPostal.filter((element) => element.STATE_ID === event.value);
          this.coloniasAUX = [];
        break;
        case 3:
          this.coloniasAUX = this.colonias.filter((element) => element.POSTAL_CODE_ID === event.value);
        break;
        default:
        break;
      }
      
    }
    
  filtroCp(val: any) {
    

    if (this.timeout) {
        clearTimeout(this.timeout);
    }

    const searchValue = val.currentTarget.value.trim().toLowerCase();
    this.timeout = setTimeout(() => {
        

        let arr: any[];

        if (searchValue !== "") {
            arr = this.postalCodeAux
                .filter((obj) => obj.NAME.toLowerCase().indexOf(searchValue) > -1)
                .slice(0, 10); // Limitar a los primeros 10 elementos
        } else {
            arr = this.postalCodeAux.slice(0, 10); // Restaurar a los primeros 10 elementos del array original
        }
        
        //console.log("filtroCp: Resultado filtrado:", arr);
        this.codigoPostalAUX = arr;
    }, 300); // Esperar 300 ms antes de ejecutar la búsqueda

    
  }
    

    guardarDireccionCompania(){
      this.mapearDatosFormularioEnModelo();
      this.agregarCompanyAddress();
    }
    mapearDatosFormularioEnModelo(){
      this.companyAddress.NAME = this.direccionCompaniaForm.controls['NAME'].value;
      this.companyAddress.pais = this.direccionCompaniaForm.controls['pais'].value;
      this.companyAddress.estado = this.direccionCompaniaForm.controls['estado'].value;
      this.companyAddress.ciudad = this.direccionCompaniaForm.controls['ciudad'].value;
      this.companyAddress.STREET = this.direccionCompaniaForm.controls['STREET'].value;
      this.companyAddress.OUTDOOR_NUMBER = this.direccionCompaniaForm.controls['OUTDOOR_NUMBER'].value;
      this.companyAddress.INTERIOR_NUMBER = this.direccionCompaniaForm.controls['INTERIOR_NUMBER'].value;
      this.companyAddress.localidad = this.direccionCompaniaForm.controls['localidad'].value;
      this.companyAddress.CP = this.direccionCompaniaForm.controls['CP'].value;
      this.companyAddress.colonia = this.direccionCompaniaForm.controls['colonia'].value;
      this.companyAddress.REFERENCE = this.direccionCompaniaForm.controls['REFERENCE'].value;
      this.companyAddress.loacs =  sessionStorage.getItem('acslo');
      this.companyAddress.COMPANY_ADDRESS_ID = this.CompanyAddres_ID;
    }
    agregarCompanyAddress(){
      this._generalService.metodoCallParams(this.companyAddress, 'DireccionCompania/addCompanyAddress').subscribe(
        (result) => {
          this.backward();
          this._generalService.toastCall('Registro '+ this.title +' exitosamente!');
          }, (error) => {
            console.log(error as any);
          });
    }
}


// WEBPACK FOOTER //
// ./src/app/direccionEmpresa/agregar-editar/direccionEmpresa-agregar.component.ts